var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__container",class:{ 'reveal--modal': _vm.show },on:{"mousedown":function($event){return _vm.$emit('close')}}},[_c('div',{ref:"modalBody",staticClass:"modal__body",class:[].concat( _vm.bodyClass ),on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618b3652","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/ModalComponent.vue
// module id = null
// module chunks = 